import { MessageTemplateCode, MessageTemplateType } from 'src/api/api.generated'

type MessageTemplateToFilter = {
  tenantId?: string | null
  code: MessageTemplateCode
  type: MessageTemplateType
  id: string
}

export function filterMessageTemplate(messageTemplate: MessageTemplateToFilter, messageTemplates: MessageTemplateToFilter[]) {
  if (messageTemplate.tenantId /* && messageTemplate.propertyId */) {
    // keeping the custom template
    return true
  }

  // check to see if is required to show the default template
  return (
    messageTemplates.filter(
      (messageTemplateToCheck) => messageTemplateToCheck.code === messageTemplate.code && messageTemplateToCheck.type === messageTemplate.type && messageTemplateToCheck.id !== messageTemplate.id,
    ).length === 0
  )
}
